import { testIdGen } from '@panwds/react-ui';
import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { pathMatch } from '../../utils/pathMatchHelper.esm.js';
import { navActions } from '../Navigation/reducer.esm.js';
import { useNavigationContext } from '../NavigationContext/NavigationContext.esm.js';

function SubNavListItem({ dataMetrics, dataTestId, title, badge, active, disabled, addClassName, url, isSimpleNav, isGrouped, onClick, }) {
    const history = useHistory();
    const location = useLocation();
    const { collapsed, dispatch } = useNavigationContext();
    const match = !disabled && (active !== null && active !== void 0 ? active : pathMatch(location.pathname, url));
    const handleClick = () => {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        if (url) {
            history.push(url);
        }
        isSimpleNav && collapsed && dispatch({ type: navActions.closeSubNav });
    };
    const onClickAction = (event) => {
        event.preventDefault();
        if (disabled)
            return;
        handleClick();
    };
    const onKeyDownAction = (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            if (disabled)
                return;
            handleClick();
        }
    };
    const classes = classNames("tw-box-border tw-flex tw-no-underline tw-items-center tw-justify-between tw-h-8", disabled
        ? "tw-opacity-60 tw-cursor-not-allowed"
        : "tw-cursor-pointer focus:tw-outline-none focus:tw-bg-blue-steel-800 dark:focus:tw-bg-gray-800 focus:tw-text-white dark:focus:tw-text-white", "tw-text-blue-steel-300 dark:tw-text-gray-400", !match &&
        !disabled &&
        "hover:tw-text-white dark:hover:tw-text-white", !collapsed && "tw-border-solid tw-border-r-0 tw-border-t-0 tw-border-b-0", !collapsed && isSimpleNav
        ? `tw-border-l-4 ${isGrouped ? "tw-pl-18" : "tw-pl-[59px]"}`
        : `tw-border-l-2 ${isGrouped ? "tw-pl-5" : "tw-pl-2"}`, "tw-text-xs tw-pr-4 tw-py-2.5", !isSimpleNav && "tw-ml-4", isSimpleNav &&
        "tw-text-dark-bg hover:tw-text-dark-bg hover:tw-no-underline", match
        ? "tw-text-white dark:tw-text-white tw-border-blue-400 tw-font-semibold tw-bg-blue-steel-700 dark:tw-bg-gray-950"
        : isSimpleNav
            ? "tw-border-transparent hover:tw-bg-blue-steel-800 dark:hover:tw-bg-gray-800 active:tw-bg-blue-steel-600 dark:active:tw-bg-gray-700"
            : "tw-border-blue-steel-800 dark:tw-border-gray-950 hover:tw-bg-blue-steel-800 dark:hover:tw-bg-gray-800 active:tw-bg-blue-steel-600 dark:active:tw-bg-gray-700", addClassName);
    return (React.createElement("li", { "data-metrics": dataMetrics, "data-testid": dataTestId || `navigation-${testIdGen(String(title))}`, className: `tw-box-border` },
        React.createElement("a", { "data-testid": dataTestId ? `${dataTestId}-subNavListItem` : "subNavListItem", className: classes, href: url, onClick: onClickAction, onKeyDown: onKeyDownAction },
            React.createElement("span", { className: "tw-truncate" }, title),
            badge)));
}

export { SubNavListItem };
//# sourceMappingURL=SubNavListItem.esm.js.map
